import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
// .mjs so plain node can import it in its test without a build step, and
// webpack resolves it natively.
import { editSummary } from './EditBadge.logic.mjs'

// The mark on a photo's tile saying it carries Lightroom edits.
//
// Without it the only way to know an edit existed was to open the photo and
// look for a sidecar, which meant a grid of a thousand raws gave no clue which
// of them had been graded.
//
// Everything here comes from the library query, which already carries each
// sidecar's version count and editors — the tile must not fire a request per
// photo to render a badge.

export default function EditBadge({ sidecars, styles }) {
  const summary = editSummary(sidecars)
  if (!summary) return null

  // The title carries the detail the chip has no room for, so hovering answers
  // "who, and how many versions" without opening the photo.
  const title = [
    `${summary.editFiles} edit file${summary.editFiles === 1 ? '' : 's'}`,
    summary.versions > 1 ? `${summary.versions} saved versions` : null,
    summary.named.length ? `edited by ${summary.named.join(', ')}` : null,
    summary.anyAnonymous ? 'includes an unattributed save' : null,
    summary.sources.length ? `from ${summary.sources.join(', ')}` : null,
    summary.hasMasks ? 'includes masks (.acr)' : null,
  ].filter(Boolean).join(' · ')

  return (
    <span className={styles.editBadge} title={title}>
      <EditIcon style={{ fontSize: '0.75rem' }} />
      {summary.label}
      {summary.versions > 1 && <em className={styles.editBadgeVersions}>×{summary.versions}</em>}
    </span>
  )
}
